import React from 'react';
import Config from '../utils/config';
import * as athenaPopups from '../utils/athenaPopups';
import Label from '../utils/label';

const popups = athenaPopups.instance[3] || [];

class Product extends React.Component {
	render() {
		const imgpath = "url(" + this.props.classname + ")";
		var imgStyle = {
			backgroundImage: imgpath
		  };
		  
		return (
			<li style={imgStyle}
				onClick={() => this.props.onClick(this.props.theURL, this.props.opentype)}>
				<div className="box">
					{this.props.isNew && <div className="new_tag">{Label.lbl_NewTag}</div>}
					<a href="javascript:void(0);">
						<h4>{this.props.name}</h4>
						<span>{this.props.message}</span>
					</a>
				</div>
			</li>
		);
	}
}

export default class Products extends React.Component {
	popupDiv(type) {
		this.props.popupDiv(type);
	}

	onItemClick = (theURL, opentype) => {
		if (opentype === '0') {
			this.props.actPara(theURL);
		}
		else if (opentype === '1') {
			const login = Config.appConfig.Logined;
			if (!login) {
				this.popupDiv(2);
			} else {
				this.openGamePage(theURL);
			}
		} else {
			this.openWindow(theURL, 4);
		}
	};

	openWindow(theURL, popupIndex){
		let oWindow;
		const PageSetting =
			'toolbar=no,location=no,status=no,menubar=no,scrollbars=yes,resizable=yes,width=1000,height=679';
		if (popups.length == 0) {
			oWindow = window.open(theURL, theURL, PageSetting);
			popups.push(oWindow);
		} else {
			for (let i = 0; i < popups.length; i++) {
				if (popups[i].closed == true) {
					popups.splice(i, 1);
				}
			}
			oWindow = window.open(theURL, theURL, PageSetting);
			popups.push(oWindow);
		}

		athenaPopups.instance[popupIndex] = popups;
	}

	openGamePage(theURL) {
		const Dep_ActStatus = Config.appConfig.ActStatus;
		if (Dep_ActStatus != '2') {
			theURL = 'CasinoAlert';
		}
		switch (theURL) {
			case 'Casino':
				theURL = 'Casino_OpenCasino.aspx';
				break;
			case 'LiveCasino':
				theURL = 'Casino_OpenLiveCasino.aspx';
				break;
			case 'CasinoAlert':
				theURL = 'Casino_Alert.aspx';
				break;
			case 'Keno':
				this.popupDiv('keno');
				theURL = '';
				break;
			default:
				theURL = 'GamePage.aspx?Game=' + theURL;
		}
		if (theURL != '') {
			this.openWindow(theURL, 3);
		}
	};

	render() {
		return (
			<div className="products">
				<ul className="num-3">
					{$.grep(this.props.productList, e => e.siteconfigkey === "true").map((pro, i) => (
						<Product
							key={i}
							name={pro.name}
							message={pro.message}
							classname={pro.classname}
							theURL={pro.theURL}
							opentype={pro.opentype}
							onClick={this.onItemClick}
							isNew={pro.isNew}
						/>
					))}
				</ul>
			</div>
		);
	}
}
